import { render, staticRenderFns } from "./ClassSlot.vue?vue&type=template&id=13d05a15&"
import script from "./ClassSlot.vue?vue&type=script&lang=js&"
export * from "./ClassSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports